import type { Bol } from "@/api/trips/dto/trip.dto";
import type { StopInfoFreight } from "@/types/trip";

class BolValidator {
  #notSelectedError = "Not selected at any freight. Select it or delete the number.";
  #duplicateError = "BOL with this number already exists.";

  #bols;
  #freights;

  constructor(bols: (Bol | null)[], freights: StopInfoFreight[]) {
    this.#bols = bols;
    this.#freights = freights;
  }

  validate(): (string | null)[] {
    const selectedBolIds = new Set(this.#freights.flatMap((freight) => freight.bolIds ?? []));

    return this.#bols.map((bol, index) => {
      if (!bol) {
        return null;
      }

      if (this.#isDuplicated(bol, index)) {
        return this.#duplicateError;
      }

      if (bol.isDeleted) {
        return null;
      }

      if (!selectedBolIds.has(bol.id)) {
        return this.#notSelectedError;
      }

      return null;
    });
  }

  #isDuplicated(bol: Bol, index: number): boolean {
    return this.#bols.some((otherBol, otherIndex) => {
      return otherIndex < index && otherBol?.number.trim() === bol.number.trim();
    });
  }
}

export default BolValidator;
